import React from 'react';
import { CheckIcon } from 'lucide-react';
interface StepIndicatorProps {
  currentStep: number;
  steps: string[];
}
export function StepIndicator({
  currentStep,
  steps
}: StepIndicatorProps) {
  return <div className="mb-8" data-id="element-21">
      {/* Mobile view: just text */}
      <div className="md:hidden text-sm font-medium text-muted-foreground mb-2" data-id="element-22">
        Step {currentStep + 1} of {steps.length}:{' '}
        <span className="text-foreground" data-id="element-23">{steps[currentStep]}</span>
      </div>

      {/* Desktop view: full indicator with connector lines */}
      <div className="hidden md:flex items-start justify-between relative" data-id="element-24">
        {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isCurrent = index === currentStep;
        const isActive = isCompleted || isCurrent;
        return <div key={step} className="flex flex-col items-center relative flex-1" data-id="element-25">
              
              {/* Connector line to the right (not on last step) */}
              {index < steps.length - 1 && <div className="absolute top-4 left-1/2 w-full h-0.5" style={{
            transform: 'translateY(-50%)'
          }} data-id="element-26">
                
                  <div className="w-full h-full bg-border" data-id="element-27" />
                  <div className="absolute top-0 left-0 h-full bg-violet-blue transition-all duration-300" style={{
              width: isCompleted ? '100%' : '0%'
            }} data-id="element-28" />
                
                </div>}

              {/* Step circle */}
              <div className={`
                  relative z-10 w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium border-2 transition-colors
                  ${isCompleted ? 'bg-violet-blue border-violet-blue text-white' : ''}
                  ${isCurrent ? 'bg-background border-violet-blue text-violet-blue' : ''}
                  ${!isCompleted && !isCurrent ? 'bg-background border-border text-muted-foreground' : ''}
                `} aria-current={isCurrent ? 'step' : undefined} data-id="element-29">
                
                {isCompleted ? <CheckIcon className="w-4 h-4" data-id="element-30" /> : index + 1}
              </div>

              {/* Step label */}
              <span className={`
                  mt-2 text-xs font-medium text-center whitespace-nowrap
                  ${isCurrent ? 'text-foreground' : 'text-muted-foreground'}
                `} data-id="element-31">
                
                {step}
              </span>
            </div>;
      })}
      </div>
    </div>;
}